import table from "@/domains/local-db/account/settings/adapter";
import config from "@/domains/local-db/account/settings/config";
import { NotesListPageParams } from "@/modules/filters/notes/types";
import { CollectionsListPageParams } from "@/store/pages/CollectionsListPageStore/types";
import type { TemplatesListPageParams } from "@/store/pages/TemplatesListPageStore/TemplatesListPageStore";

export const getNotesListPageParams = async (): Promise<Partial<NotesListPageParams>> => {
  const paramsResponse = await table.get(config.NOTES_LIST_PAGE_PARAMS_KEY);
  const paramsString = paramsResponse?.[config.NOTES_LIST_PAGE_PARAMS_KEY];
  return paramsString ? JSON.parse(paramsString) : {};
};

export const getTemplatesListPageParams = async (): Promise<Partial<TemplatesListPageParams>> => {
  const paramsResponse = await table.get(config.TEMPLATES_LIST_PAGE_PARAMS_KEY);
  const paramsString = paramsResponse?.[config.TEMPLATES_LIST_PAGE_PARAMS_KEY];
  return paramsString ? JSON.parse(paramsString) : {};
};

export const getCollectionsListPageParams = async (): Promise<
  Partial<CollectionsListPageParams>
> => {
  const paramsResponse = await table.get(config.COLLECTIONS_LIST_PAGE_PARAMS_KEY);
  const paramsString = paramsResponse?.[config.COLLECTIONS_LIST_PAGE_PARAMS_KEY];
  return paramsString ? JSON.parse(paramsString) : {};
};

export const getCollectionsViewPageParams = async (
  collectionId: string
): Promise<Partial<NotesListPageParams>> => {
  const paramsResponse = await table.get(config.getCollectionsViewPageParamsKey(collectionId));
  const paramsString = paramsResponse?.[config.COLLECTIONS_VIEW_PAGE_PARAMS_KEY];
  return paramsString ? JSON.parse(paramsString) : {};
};
